import React, { Component } from 'react';
import T from 'prop-types';
// components
import ReactSelect from 'react-select';
import Creatable from 'react-select/lib/Creatable';
// styles
import 'react-select/dist/react-select.css';
import styles from './Select.mod.css';
import classnames from 'classnames/bind';
import Icon from '../Icon/Icon';

let cx = classnames.bind(styles);

class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: props.defaultValue || ''
    };
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption });
  };

  render() {
    const { className, options, isCreatable, ...otherProps } = this.props;
    const { selectedOption } = this.state;

    const Component = isCreatable ? Creatable : ReactSelect;

    return (
      <Component
        className={cx(styles.select, className)}
        isSearchable={true}
        value={selectedOption}
        onChange={this.handleChange}
        options={options}
        arrowRenderer={() => (
          <Icon type="chevron-up" className={styles.arrowIcon} />
        )}
        clearRenderer={() => <Icon type="close" className={styles.clearIcon} />}
        {...otherProps}
      />
    );
  }
}

Select.propTypes = {
  className: T.string,
  isCreatable: T.bool,
  options: T.arrayOf(
    T.shape({
      value: T.oneOfType([T.string, T.number]),
      label: T.string.isRequired
    })
  )
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select/Select.jsx